<template>
  <b-card v-if="data">
    <b-row
      align-v="center"
      align-h="between"
    >
      <b-col md="8">
        <h4>{{ data.name }}</h4>
        <div class="d-flex">
          <p class="text-muted mb-0">
            {{ data.merchant.name }}
          </p>
          <p class="text-muted mb-0 mx-1">
            |
          </p>
          <p
            v-if="data.updated_at"
            class="mb-0"
          >
            <span class="text-muted">Terakhir diubah pada</span> {{ formatSelectDate(data.updated_at, ['date','month','year','time']) }}
          </p>
          <p
            v-else
            class="mb-0"
          >
            <span class="text-muted">Dibuat pada</span> {{ formatSelectDate(data.created_at, ['date','month','year','time']) }}
          </p>
        </div>
      </b-col>
      <b-col
        cols="auto"
        class="text-right"
      >
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="toExternalLink(`/${data.merchant.slug}/${data.slug}`)"
        >
          Lihat Produk
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
// bootstrap vue
import {
  BButton, BCard, BRow, BCol,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
}
</script>
